export const BASE_URL = "http://webservices-v2.crous-mobile.fr/feed/";
